import { appConfig } from "@/config/app.config";
import { logger } from "./logger";

/**
 * Sentry integration placeholder
 *
 * To enable Sentry:
 * 1. Install @sentry/react
 * 2. Set VITE_SENTRY_DSN in environment
 * 3. Uncomment and configure the init function
 */

interface SentryConfig {
  dsn: string;
  environment: string;
  release: string;
}

export function initSentry(): void {
  if (!appConfig.observability.enableSentry) {
    logger.debug("Sentry disabled (no DSN or not in production)");
    return;
  }

  const config: SentryConfig = {
    dsn: appConfig.observability.sentryDsn ?? "",
    environment: import.meta.env.MODE,
    release: `vision@${appConfig.version}`,
  };

  logger.info("Sentry would be initialized with config", {
    environment: config.environment,
    release: config.release,
  });

  // TODO: Uncomment when @sentry/react is installed
  // import * as Sentry from '@sentry/react';
  // Sentry.init({
  //   dsn: config.dsn,
  //   environment: config.environment,
  //   release: config.release,
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     Sentry.replayIntegration(),
  //   ],
  //   tracesSampleRate: 0.1,
  //   replaysSessionSampleRate: 0.1,
  //   replaysOnErrorSampleRate: 1.0,
  // });
}

export function captureException(
  error: Error,
  context?: Record<string, unknown>,
): void {
  logger.error("Exception captured", { error: error.message, ...context });

  // TODO: Uncomment when @sentry/react is installed
  // if (appConfig.observability.enableSentry) {
  //   Sentry.captureException(error, { extra: context });
  // }
}

export function captureMessage(
  message: string,
  context?: Record<string, unknown>,
): void {
  logger.info("Message captured", { message, ...context });

  // TODO: Uncomment when @sentry/react is installed
  // if (appConfig.observability.enableSentry) {
  //   Sentry.captureMessage(message, { extra: context });
  // }
}
